import type { definitions } from '@luxuryescapes/contract-svc-agent'
import request from 'api/requestUtils'

type ExpressionOfInterestRequest = definitions['eoiCreateRequest']

export interface ExpressionOfInterestData {
  agencyName: string
  affiliationId: string
  givenName: string
  surname: string
  phone: string
  email: string
  regionCode: App.AgentHubEoiRegions
  referrerEmail?: string
  title: App.Title
  businessCodeType?: string
  businessCodeValue?: string
  streetAddress?: string
  city?: string
  stateOrTerritory?: string
  postcode?: string
  country?: string
}

async function requestPostExpressionOfInterest(agencyData: ExpressionOfInterestData) {
  const requestBody: ExpressionOfInterestRequest = {
    agencyName: agencyData.agencyName,
    affiliationId: agencyData.affiliationId,
    givenName: agencyData.givenName,
    surname: agencyData.surname,
    phone: agencyData.phone,
    email: agencyData.email,
    regionCode: agencyData.regionCode,
    ...(agencyData.referrerEmail && { referrerEmail: agencyData.referrerEmail }),
    title: agencyData.title,
    ...(agencyData.businessCodeType && { businessCodeType: agencyData.businessCodeType }),
    ...(agencyData.businessCodeValue && { businessCodeValue: agencyData.businessCodeValue }),
    ...(agencyData.streetAddress && { streetAddress: agencyData.streetAddress }),
    ...(agencyData.city && { city: agencyData.city }),
    ...(agencyData.stateOrTerritory && { stateOrTerritory: agencyData.stateOrTerritory }),
    ...(agencyData.postcode && { postcode: agencyData.postcode }),
    ...(agencyData.country && { country: agencyData.country }),
  }

  return request.post(
    '/api/agent/eoi',
    requestBody,
  )
}

export default requestPostExpressionOfInterest
